import * as React from 'react'
import { Hit } from 'react-instantsearch-core'
import { Highlight } from 'react-instantsearch-dom'

import { ICompositePage } from '../../../models/algolia/composite'
import { TableViewOptions } from './any-hit'
import { HitTableRow } from './hit-table-row'

type TableViewProps = TableViewOptions & {
  hit: Hit<ICompositePage>,
}

export class PageHitTableView extends React.PureComponent<TableViewProps> {

  public render() {
    const { hit } = this.props
    const slug = hit.Page.slug

    return <HitTableRow
      hit={hit}
      slug={slug}
      title={<Highlight attribute="Page.display_title" hit={hit} />}
      className="site-search-hit__page"
    >
      <p><Highlight attribute="Page.description" hit={hit} /></p>
      <p className="meta-data">Learn More</p>
    </HitTableRow>
  }
}
